import {
  Autocomplete,
  Box,
  BoxStatus,
  GraphicFilters,
  Input,
  Label,
  PieCharts,
  Select,
  shootToast,
  Stack,
  StackRow,
} from "codekit";
import {
  useGenerateExcelMutation,
  useGetDataGraphicMutation,
  useGetDataGroupsMutation,
} from "../../../../libs/redux/slices/Graficsx/Ingeprop/ingepropApiSlice";
import { useCallback, useEffect, useState } from "react";
import { useGetClientGraphicByIdMutation } from "../../../../libs/redux/slices/Reportxx/Repfinac/repfinacApiSlice";
import { Controller, useForm, useWatch } from "react-hook-form";
import { convertCurrencyNumber, getActualDate } from "../../../../utils/globalFunctions";

const colorChart = ["secondary", "success", "warning", "error", "accent", "primary", "info", "neutral"];

const Ingeprop = ({ graphName }) => {
  const [getClientById] = useGetClientGraphicByIdMutation();
  const [resultsClient, setResultsClient] = useState([]);
  const [getDataGraphic] = useGetDataGraphicMutation();
  const [getDataGroups] = useGetDataGroupsMutation();
  const [generateExcel] = useGenerateExcelMutation();
  const [total, setTotal] = useState(0);
  const [dataGraphic, setDataGraphic] = useState([]);
  const [colorsChart, setColorsChart] = useState([]);
  const firstDate = `${getActualDate().substring(0, 8)}01`;
  const { control, register, reset, setValue } = useForm({
    mode: "onBlur",
    defaultValues: { FECHINIT: firstDate, FECHFINT: getActualDate(), TIPOFILT: "FACTURACION", CCOIDXXX: "" },
  });
  const values = useWatch({ control });
  const [dataGraphicGroups, setDataGraphicGroups] = useState([]);
  const [isGraphicGroups, setGraphicGroups] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const searchClient = async (CLIIDXXX, cb) => {
    return await getClientById({
      filters: { CLIIDXXX },
    })
      .unwrap()
      .then((response) => {
        setResultsClient(response.data);
      })
      .catch((err) => {
        console.log("entro en el catch", err);
      })
      .finally(() => {
        cb();
      });
  };

  //Funcion para la consulta de informacion de la Graphica
  const handleGetData = useCallback(
    async (values) => {
      setIsLoading(true);
      let filters = {};
      filters = {
        ...values,
        CLIIDXXX: values.CLIIDXXX ? values.CLIIDXXX.split(" - ")[0] : "",
      };
      await getDataGraphic({ filters })
        .unwrap()
        .then((response) => {
          const { data } = response;
          let totalData = 0;
          let percentage = {};
          data.forEach((element) => {
            totalData += parseFloat(element.MDTCVLRX);
          });
          data.forEach((element) => {
            const value = (parseFloat(element.MDTCVLRX) * 100) / totalData;
            percentage = {
              ...percentage,
              [element.CCOIDXXX]: value.toFixed(2),
            };
          });
          setDataGraphic(
            data.map((item) => ({
              name: item.CCODESXX,
              value: parseFloat(item.MDTCVLRX),
              date: `${percentage[item.CCOIDXXX]} %`,
              CCOIDXXX: item.CCOIDXXX,
            })),
          );
          setColorsChart(
            data.map((item, index) => ({
              colorCellChart: `${colorChart[index]}-500`,
              bgColorCards: `${colorChart[index]}-100`,
              iconColor: `${colorChart[index]}-400`,
              textColor: `${colorChart[index]}-600`,
            })),
          );
          setTotal(totalData);
        })
        .catch();
      setIsLoading(false);
    },
    [getDataGraphic],
  );

  //Funcion para la generacion del excel
  const handleGenerateExcel = async (context) => {
    let filters = {
      ...values,
      CLIIDXXX: values.CLIIDXXX ? values.CLIIDXXX.split(" - ")[0] : "",
    };
    if (context) {
      const {
        data: { CCOIDXXX, GRUPIDXX },
      } = context;
      filters = { ...filters, CCOIDXXX, GRUPIDXX };
    }
    await generateExcel({ filters })
      .unwrap()
      .then(() => {
        shootToast({
          variant: "success",
          text: "Tu reporte se esta generando! \n En Pocos minutos recibiras las confirmación del mismo por correo electronico",
          duration: 5000,
        });
      })
      .catch();
  };

  /**
   * Funcion para consultar los ingresos por grupos de una gerencia
   */
  const handleViewGroups = useCallback(
    async (values) => {
      let filters = {
        ...values,
        CLIIDXXX: values.CLIIDXXX ? values.CLIIDXXX.split(" - ")[0] : "",
      };
      await getDataGroups({ filters })
        .unwrap()
        .then((response) => {
          const { data } = response;
          let totalData = 0;
          let percentage = {};
          data.forEach((element) => {
            totalData += parseFloat(element.MDTCVLRX);
          });
          data.forEach((element) => {
            const value = (parseFloat(element.MDTCVLRX) * 100) / totalData;
            percentage = {
              ...percentage,
              [element.GRUPIDXX]: value.toFixed(2),
            };
          });
          setDataGraphicGroups(
            data.map((item) => ({
              name: item.GRUPDESX,
              value: parseFloat(item.MDTCVLRX),
              date: `${percentage[item.GRUPIDXX]} %`,
              CCOIDXXX: item.CCOIDXXX,
              GRUPIDXX: item.GRUPIDXX,
            })),
          );
          setColorsChart(
            data.map((item, index) => ({
              colorCellChart: `${colorChart[index]}-500`,
              bgColorCards: `${colorChart[index]}-100`,
              iconColor: `${colorChart[index]}-400`,
              textColor: `${colorChart[index]}-600`,
            })),
          );
          setTotal(totalData);
        })
        .catch();
    },
    [getDataGroups],
  );

  //Hook para volver a realizar consulta cuando cambia algun filtro
  useEffect(() => {
    if (!isGraphicGroups) {
      handleGetData(values);
    } else {
      handleViewGroups(values);
    }
  }, [handleGetData, values, isGraphicGroups, handleViewGroups]);

  return (
    <>
      <Box spacing={4}>
        <GraphicFilters
          containerName={graphName}
          graphicKeyName="ingeprop"
          clearFilters={() => {
            reset();
            setGraphicGroups(false);
          }}
          onClickVerMas={() => {
            handleGenerateExcel();
          }}
        >
          <Box>
            <Box mb={8} borderBottom={1} spacing={2}>
              <Stack gap={3} columnsVariant="form-3">
                <StackRow>
                  <Label>Cliente</Label>
                  <Controller
                    control={control}
                    name={`CLIIDXXX`}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <Autocomplete
                        placeholder="Buscar..."
                        textLoading="Buscando..."
                        textNoResults="No se encontraron registros"
                        minLengthToSearch={2}
                        selected={value}
                        searchResults={resultsClient}
                        onChangeSearch={(value, cb) => searchClient(value, cb)}
                        onItemClick={(context) => {
                          onChange(`${context.item.label}`);
                        }}
                        onResetSelected={() => {
                          onChange("");
                        }}
                      />
                    )}
                  />
                </StackRow>
                <StackRow>
                  <Label>Fecha Inicial</Label>
                  <Input type="date" {...register("FECHINIT")} />
                </StackRow>
                <StackRow>
                  <Label>Fecha Final</Label>
                  <Input type="date" {...register("FECHFINT")} />
                </StackRow>
                {/* <StackRow>
                  <Label>Tipo de Filtro</Label>
                  <Controller
                    control={control}
                    name={`TIPOFILT`}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <Select
                        value={value}
                        options={[
                          { text: "SELECCIONE", value: "" },
                          { text: "FECHA FACTURACION", value: "FACTURACION" },
                          { text: "FECHA CREACION", value: "CREACION" },
                          { text: "FECHA DE LEVANTE", value: "LEVANTE" },
                        ]}
                        onChangeValue={(context) => {
                          onChange(context.option.value);
                        }}
                      />
                    )}
                  />
                </StackRow> */}
                <StackRow>
                  <Label>Tipo de Operación</Label>
                  <Controller
                    control={control}
                    name={`DOCTIPXX`}
                    rules={{ required: true }}
                    render={({ field: { onChange, value } }) => (
                      <Select
                        value={value}
                        options={[
                          { text: "SELECCIONE", value: "" },
                          { text: "IMPORTACION", value: "IMPORTACION" },
                          { text: "EXPORTACION", value: "EXPORTACION" },
                          { text: "REGISTRO", value: "REGISTRO" },
                          { text: "TRANSITO", value: "TRANSITO" },
                          { text: "OTROS", value: "OTROS" },
                        ]}
                        onChangeValue={(context) => {
                          onChange(context.option.value);
                        }}
                      />
                    )}
                  />
                </StackRow>
              </Stack>
            </Box>
            <Box>
              {isLoading ? (
                <BoxStatus variant="loading" text="Cargando Información..." />
              ) : (
                <>
                  {!isGraphicGroups ? (
                    <>
                      {dataGraphic.length > 0 ? (
                        <Stack gap={8}>
                          <StackRow>
                            <PieCharts
                              onClickCellChart={(context) => {
                                setGraphicGroups(true);
                                setValue("CCOIDXXX", context?.data?.CCOIDXXX);
                              }}
                              onClickIconCard={(context) => {
                                handleGenerateExcel(context);
                              }}
                              onClickCard={(context) => {
                                setGraphicGroups(true);
                                setValue("CCOIDXXX", context?.data?.CCOIDXXX);
                              }}
                              data={dataGraphic}
                              chartColors={colorsChart}
                              labelOne={convertCurrencyNumber(total)}
                              labelTwo="Ingresos"
                              isCurrency={true}
                              titleIcon="Generar Excel"
                            />
                          </StackRow>
                        </Stack>
                      ) : (
                        <BoxStatus variant="empty" text="Esta sección está vacía" />
                      )}
                    </>
                  ) : (
                    <>
                      {dataGraphicGroups.length > 0 ? (
                        <Stack gap={8}>
                          <StackRow>
                            <PieCharts
                              onClickCellChart={(context) => {
                                handleGenerateExcel(context);
                              }}
                              onClickIconCard={(context) => {
                                handleGenerateExcel(context);
                              }}
                              data={dataGraphicGroups}
                              chartColors={colorsChart}
                              labelOne={convertCurrencyNumber(total)}
                              labelTwo="Ingresos"
                              isCurrency={true}
                              titleIcon="Generar Excel"
                            />
                          </StackRow>
                        </Stack>
                      ) : (
                        <BoxStatus variant="empty" text="Esta sección está vacía" />
                      )}
                    </>
                  )}
                </>
              )}
            </Box>
          </Box>
        </GraphicFilters>
      </Box>
    </>
  );
};

export default Ingeprop;
